import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import Boxer100 from "./pages/products/boxer100";
import Boxer150 from "./pages/products/boxer150";
import Pulsar150 from "./pages/products/pulsar150";
import Pulsar180 from "./pages/products/pulsar180";
import Pulsar200 from "./pages/products/pulsar200";
import Pulsar220 from "./pages/products/pulsar220";
import Discover125 from "./pages/products/discover125";
import Discover150 from "./pages/products/discover150";
import Daily from "./pages/products/daily";
import MaximaZ from "./pages/products/maxima-z";
import RECompact from "./pages/products/re-compact";
import Qute from "./pages/products/qute";
import Maxima from "./pages/products/maxima";
import MaximaC from "./pages/products/maxima-c";
import Max7 from "./pages/products/max7";
import Dream from "./pages/products/dream";
import Tooth from "./pages/products/tooth"

import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/boxer100" element={<Boxer100 />} />
        <Route path="/products/boxer150" element={<Boxer150 />} />
        <Route path="/products/pulsar150" element={<Pulsar150 />} />
        <Route path="/products/pulsar180" element={<Pulsar180 />} />
        <Route path="/products/pulsar200" element={<Pulsar200 />} />
        <Route path="/products/pulsar220" element={<Pulsar220 />} />
        <Route path="/products/discover125" element={<Discover125 />} />
        <Route path="/products/discover150" element={<Discover150 />} />
        <Route path="/products/daily" element={<Daily />} />
        <Route path="/products/maxima-z" element={<MaximaZ />} />
        <Route path="/products/re-compact" element={<RECompact />} />
        <Route path="/products/qute" element={<Qute />} />
        <Route path="/products/maxima" element={<Maxima />} />
        <Route path="/products/maxima-c" element={<MaximaC />} />
        <Route path="/products/max7" element={<Max7 />} />
        <Route path="/products/dream" element={<Dream />} />
        <Route path="/products/tooth" element={<Tooth />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;